import styled from "styled-components";
import { textStyleBody2, textStyleBody3 } from "..";

export const TableWrapper = styled.table`
  border: 1px solid var(--Gray);
  border-radius: 0.5rem;
  border-spacing: 0;
  overflow: hidden;
  width: 100%;
`;

export const TableHeaderCell = styled.th`
  ${textStyleBody3}
  width: ${(props) => props.width || "auto"};
  padding: 1.2rem 1rem;
  background: var(--LightGray);
  border-bottom: 1px solid var(--Gray);
`;

export const TableCell = styled.td`
  ${textStyleBody2}
  width: ${(props) => props.width || "auto"};
  padding: 1.2rem 1rem;
  background: var(--White);
  border-bottom: 1px solid var(--Gray);
`;

export const TableRow = styled.tr`
  &:last-child {
    ${TableCell}, ${TableHeaderCell} {
      border-bottom: none;
    }
  }
`;
